import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { InitiativeWithProgressOutput } from "../../generated/graphql";
import {
  GET_INITIATIVES_AND_REFDOCS,
  GetInitiativesAndRefdocsData,
} from "./home2.queries";

export function useInitiatives() {
  const { loading, error, data, refetch } = useQuery<GetInitiativesAndRefdocsData>(
    GET_INITIATIVES_AND_REFDOCS,
    {
      fetchPolicy: "no-cache",
    }
  );

  const initiatives = useMemo((): InitiativeWithProgressOutput[] => {
    if (!data?.getInitiativesForLearnerWithProgress) return [];

    let list = [...data.getInitiativesForLearnerWithProgress];

    // Sort by assignment date (most recent first)
    list.sort((a, b) => b.assignmentDate - a.assignmentDate);

    // Move last active initiative to top
    list.sort((a) => (a.isLastActiveInitiative ? -1 : 1));

    const completed = list.filter((i) => i.progress >= 100);
    const inProgress = list.filter((i) => i.progress < 100);

    return [...inProgress, ...completed];
  }, [data]);

  const refdocCountByDocumentId = useMemo((): Record<number, number> => {
    const map: Record<number, number> = {};
    if (!data?.getRefdocViewCount) return map;
    for (const row of data.getRefdocViewCount) {
      map[row.document_id] = row.count ?? 0;
    }
    return map;
  }, [data]);

  return {
    loading,
    error,
    data,
    refetch,
    initiatives,
    referenceDocuments: data?.getReferenceDocumentsForLearner ?? [],
    refdocCountByDocumentId,
    learnerDetails: data?.getLearnerDetails,
    learnerFirstName: data?.getLearnerDetails?.first_name,
  };
}
